"use strict";

/**
 * Partner-Seite: Bewertungs-Block
 */

var _ = require('underscore');

var RatingsModel = require('./RatingsModel');
var RatingsView = require('./views/RatingsView');


var ClientRatings = function(options) {
    _.extendOwn(this, {
		api: '/api/rating/',
		client: null,
		container: null,
    }, options);

    this.ratingsModel = new RatingsModel({
        client: this.client,
        api: this.api,
    });
    this.ratingsView = new RatingsView({
        model: this.ratingsModel,
        el: this.container,
    });
};


ClientRatings.prototype.run = function() {
    this.ratingsModel.loadMore();
    this.ratingsView.render();	
};

module.exports = ClientRatings;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/miniengine/ratings.js